import(/* webpackMode: "eager" */ "/home/runner/work/web.drivingplus/web.drivingplus/src/app/academy/academy.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/app/academy/components/academy-view-count-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/app/academy/components/scroll-restore-popstate-listener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/app-install-popup.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/service-maintenance-overlay.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingplus/web.drivingplus/src/components/study-king-and-test40-result/main-section.tsx");
